import {
  EXPENSE_CASH_FILTERS,
  EXPENSE_CASH_FILTER_LABELS,
  type ExpenseCashFilter,
} from '@peles/shared';

/** `overdue,due30` → the filters it names; anything unknown ("all" included) drops out. */
export function parseCashFilters(value: string | null): ExpenseCashFilter[] {
  if (!value) return [];
  return value
    .split(',')
    .map((v) => v.trim())
    .filter((v): v is ExpenseCashFilter => EXPENSE_CASH_FILTERS.includes(v as ExpenseCashFilter));
}

/**
 * The Expenses list's quick cash filters — Overdue, Due in 30 days, Unpaid,
 * Paid — as toggles, any of which matches. Applied by the server, so the rows,
 * the count and the summary all describe the lines picked.
 */
export function CashFilterChips({
  value,
  onChange,
}: {
  value: ExpenseCashFilter[];
  onChange: (next: ExpenseCashFilter[]) => void;
}) {
  const toggle = (filter: ExpenseCashFilter) =>
    onChange(
      value.includes(filter)
        ? value.filter((v) => v !== filter)
        : EXPENSE_CASH_FILTERS.filter((f) => f === filter || value.includes(f)),
    );
  return (
    <div className="flex flex-wrap gap-2" role="group" aria-label="Payment filters">
      {EXPENSE_CASH_FILTERS.map((filter) => {
        const on = value.includes(filter);
        return (
          <button
            key={filter}
            type="button"
            aria-pressed={on}
            onClick={() => toggle(filter)}
            className={`min-h-11 sm:min-h-8 px-3 text-sm rounded-full border ${
              on
                ? 'bg-primary-600 border-primary-600 text-white'
                : 'border-gray-300 text-gray-700 hover:bg-gray-50'
            }`}
          >
            {EXPENSE_CASH_FILTER_LABELS[filter]}
          </button>
        );
      })}
      {value.length > 0 && (
        <button
          type="button"
          onClick={() => onChange([])}
          className="min-h-11 sm:min-h-8 px-2 text-sm text-gray-500 underline"
        >
          Show all
        </button>
      )}
    </div>
  );
}
